// @ts-nocheck

"use client";

import {
  ImageUrlBuilder,
  useNextSanityImage,
  UseNextSanityImageProps,
} from "next-sanity-image";
import Image from "next/image";

import { Figure } from "@/sanity/sanity.types";
import { client } from "@/sanity/sanityClient";

export type SanityImageTypes = {
  figure: Figure;
  className?: string;
  style?: React.CSSProperties;
  sizes?: any;
  layout?: "fill" | "responsive" | "intrinsic" | undefined;
};

const getPositionFromHotspot = (hotspot) => {
  if (!hotspot || !hotspot.x || !hotspot.y) return "center";

  return `${hotspot.x * 100}% ${hotspot.y * 100}%`;
};

const SanityImage = ({
  figure,
  sizes,
  style = {},
  layout = "fill",
  className,
}: SanityImageTypes) => {
  const { asset, hotspot, crop, alt = "" } = figure || {};

  const myCustomImageBuilder = (
    imageUrlBuilder: ImageUrlBuilder,
    options: any
  ) => {
    return imageUrlBuilder
      .width(Math.round(options.croppedImageDimensions?.width, 1200))
      .height(Math.round(options.croppedImageDimensions?.height, 1200))
      .quality(90)
      .fit("clip");
  };
  const imageProps: UseNextSanityImageProps = useNextSanityImage(
    client,
    { ...asset, hotspot, crop },
    {
      imageBuilder: myCustomImageBuilder,
    }
  );

  const blurprops = {
    placeholder: "blur",
    blurDataURL: asset?.metadata?.lqip,
  };

  const objectPosition = getPositionFromHotspot(hotspot || {});

  const fillProps = {
    src: imageProps?.src,
    loader: imageProps?.loader,
    fill: true,
    sizes: sizes ?? "90vw",
    style: { objectFit: "cover", objectPosition: objectPosition, ...style },
    ...(asset?.metadata?.lqip && { ...blurprops }),
  };

  const responsiveProps = {
    ...imageProps,
    style: { width: "100%", height: "auto", ...style },
    sizes: sizes ?? "(max-width: 1248px) 100vw, 800px",
    ...(asset?.metadata?.lqip && { ...blurprops }),
  };

  return (
    <Image
      {...(layout === "fill" ? fillProps : responsiveProps)}
      className={className}
      title=""
      alt={alt}
    />
  );
};

export default SanityImage;
